import React, { useState } from 'react';
import ScrollContainer from "react-indiana-drag-scroll";
import NoDataFound from '../../shared/NoDataFound';
import { alphaformatDateTime } from "../../utils/dateFormat";
import TableLoader from '../../shared/TableLoader';
import config from "../../config";
import Select from 'react-select';
import Datepicker from 'react-tailwindcss-datepicker';
import Modal from './components/Modal'; 
import Paginator from '../../shared/Paginator';
import { renderLocationDetails, renderSalesPersonCell } from '../Designer/utils/cellRenderers';
const types = [
  {
    value: "all",
    label: "All",
  },
  {
    value: "full_image",
    label: "Full Image",
  },
  {
    value: "full_video",
    label: "Full Video",
  },
  {
      value:"half_video",
      label:"Half Video"
  },
  {
    value: "promoted_image_story",
    label: "Promoted Image Story ",
  },
  {
    value:"promoted_video_story",
    label:"Promoted Video Story"
  }
]
const CompleteAds = ({Designs,setDesigns,loader,setloader,handleWriteContentClick,totalcomplete,currentPage,setCurrentPage,handlePageChange}) =>{
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState(''); 

  const openModal = (content) => {
    setModalContent(content);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setModalContent('');
  };
  return(
    <div>
      <ScrollContainer>
        <table className="table table-bordered">
          <thead>
            <tr className="bg-gray-100">
              <th className="p-2 text-left">Sales Person Details</th>
              <th>Campaign Name</th>
              <th>Location Details</th>
              <th>Ad Type</th>
              <th>Adops</th>
              <th>Assign Time</th>
              {/* <th>Completed Time</th> */}
              {/* New column for Rough Description */}
              <th>Rough Description</th>
              <th>Action</th>
            </tr>
          </thead>
          {(Designs.length > 0 && !loader) ? (
            Designs.map((row, idx) => {
              const assign_date = alphaformatDateTime(row.assigndate);
              return (
                <tbody key={idx}>
                  <tr className="border-t">
                    <td>{renderSalesPersonCell(row.sales_person,row)}</td>
                    <td>{row.creative_name}</td>
                    <td>{renderLocationDetails(row)}</td>
                    <td>{row.ad_creative_sub_type}</td>
                    <td>{row.cst_name}</td>
                    <td className="p-2 font-bold">
                      <div>{assign_date.dateStr}</div>
                      <div className="text-xs text-gray-500">{assign_date.timeStr}</div>
                    </td>
                    {/* <td className="p-2 font-bold">
                      <div>{completion_date.dateStr}</div>
                      <div className="text-xs text-gray-500">{completion_date.timeStr}</div>
                    </td> */}
                    <td>
                      <button
                        className="bg-blue-600 text-white px-3 py-1 rounded"
                        onClick={() => openModal(JSON.parse(row.content_rough_description))}
                      >
                        Show Rough Description
                      </button>
                    </td>
                    <td>
                      <button
                        className={`bg-green-600 text-white px-3 py-1 rounded`}
                        onClick={()=>handleWriteContentClick(row,1)}
                      >
                        Edit Content
                      </button>
                    </td>
                  </tr>
                </tbody>
              );
            })
          ) : (!Designs.length && !loader) ? (
            <NoDataFound colspan="12" />
          ) : (
            <TableLoader colspan="12" />
          )}
        </table>
      </ScrollContainer>
      <Modal show={showModal} onClose={closeModal} content={modalContent} />
      <div className="flex justify-end">
        {Math.ceil(totalcomplete / config.PER_PAGE)  > 1 && (
          <Paginator
            pageCount={Math.ceil(totalcomplete / config.PER_PAGE)}
            handlePageClick={handlePageChange}
            forcePage={currentPage}
          />)
        }
      </div>
    </div>
  );
};

export default CompleteAds;
